<template>
  <section id="hero">
    <v-parallax
      dark
      :height="minHeight"
      :src="require('@/assets/pattern-6.jpg')"
      class="white--text"
      gradient="to right, rgba(5, 11, 31, .8), rgba(5, 11, 31, .8)"
    >
      <!-- <v-img
      :min-height="minHeight"
      :src="require('@/assets/home-hero.jpg')"
      class="white--text"
      gradient="to right, rgba(5, 11, 31, .8), rgba(5, 11, 31, .8)"
    > -->
      <v-container class="fill-height px-4 py-12">
        <v-responsive
          class="d-flex align-start"
          height="20%"
          width="100%"
        />
        <v-responsive
          class="d-flex align-start"
          height="100%"
          width="40%"
        >
          <v-row justify="end">
            <v-col>
              <base-heading title="LENDING REINVENTED" />
            </v-col>
          </v-row>

          <base-body>
            HEQ lending is like nothing you have ever experienced.  Come explore the
            revolutionary new experience and see for yourself.
          </base-body>

          <div
            :class="$vuetify.breakpoint.smAndDown ? 'flex-column align-start' : 'align-center'"
            class="d-flex flex-wrap"
          >
            <base-btn
              :to="{name: 'Products'}"
            >
              Discover More
            </base-btn>

            <span class="font-weight-bold ml-6 mr-4 my-4">or</span>

            <base-btn
              :to="{name: 'HEQ Loans'}"
              :ripple="false"
              class="pa-1"
              height="auto"
              text
            >
              Get Started Now
            </base-btn>
          </div>
        </v-responsive>
        <v-responsive
          class="d-flex align-center"
          height="100%"
          width="20%"
        />
        <v-responsive
          class="d-flex align-start float-right"
          height="100%"
          width="40%"
        >
          <v-row justify="end">
            <v-col>
              <base-heading
                title="CRYPTO REINVENTED"
                class="float-right text-right"
              />
            </v-col>
          </v-row>

          <v-row justify="end">
            <v-col>
              <base-body
                class="float-right text-right"
              >
                The HEQ Tokens are innovative stablecoins backed by real assets.
              </base-body>
            </v-col>
          </v-row>

          <token-summary-card />

          <!-- <div
            :class="$vuetify.breakpoint.smAndDown ? 'flex-column align-start' : 'align-center'"
            class="d-flex flex-wrap float-right"
          >
            <base-btn
              :to="{name: 'HEQ Token'}"
            >
              Discover More
            </base-btn>

            <span class="font-weight-bold ml-6 mr-4 my-4">or</span>

            <base-btn
              :to="{name: 'HEQ Loans'}"
              :ripple="false"
              class="pa-1"
              height="auto"
              text
            >
              Get Started Now
            </base-btn>
          </div> -->
        </v-responsive>
      </v-container>
    <!-- </v-img> -->
    </v-parallax>
  </section>
</template>

<script>
  import AnimatedNumber from 'animated-number-vue'

  export default {
    name: 'SectionHero',

    components: {
      AnimatedNumber,
      TokenSummaryCard: () => import('@/components/TokenSummaryCard'),
    },

    provide: {
      theme: { isDark: true },
    },

    computed: {
      minHeightFormatted () {
        const height = this.$vuetify.breakpoint.mdAndUp ? '100vh' : '50vh'

        return `calc(${height} - ${this.$vuetify.application.top}px)`
      },

      minHeight () {
        return this.$vuetify.breakpoint.height > 800 ? this.$vuetify.breakpoint.height : 800
      },

    },
    methods: {
      numberWithCommas (x) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      },
    },
  }
</script>
